export default __webpack_public_path__ + "static/media/animated-squares.2a1245b8.svg";